import { Autocomplete, FormHelperText, Grid, TextField } from '@mui/material'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'
import { DatePicker } from '../../../../../shared/components/inputs'
import { Slider } from '../../../models/sliders'

type ComplementsInfoFormProps = {
  type: number
  sliderState: Slider
  handleInputChange: (inputName: string, value: any) => void
  titleLanguages: any[]
  setTitleLanguages: (languages: any[]) => void
}

const ComplementsInfoForm = ({ type, sliderState, handleInputChange, titleLanguages, setTitleLanguages }: ComplementsInfoFormProps) => {
  const { t } = useTranslation(['global'])
  const { languages } = useSelector((state: IRootState) => state.language)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleMultiAutoCompleteChange = (inputName: string) => async (_event: any, value: any) => {
    let optionsMulti: number[] = []
    let tmpTitleLanguages = []
    if (value !== null) {
      for (let i = 0; i < value.length; i++) {
        tmpTitleLanguages.push({
          id: value[i].id,
          title: ''
        })
        optionsMulti.push(value[i].id)
      }
    }

    handleInputChange(inputName, optionsMulti)
    setTitleLanguages(tmpTitleLanguages)
  }

  const handleTitleLanguageChange = (index: number) => (event: ChangeEvent<HTMLInputElement>) => {
    let tmpTitleLanguages = [...titleLanguages]
    tmpTitleLanguages[index].title = event.target.value
    setTitleLanguages(tmpTitleLanguages)
  }

  return (
    <Grid container spacing={2}>
      {type !== 3 && (
        <>
          <Grid item xs={12} sm={6}>
            <DatePicker label="start-date" inputName="startDate" value={sliderState.startDate} handleInputChange={handleInputChange} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="end-date"
              inputName="endDate"
              minDate={sliderState.startDate}
              value={sliderState.endDate}
              handleInputChange={handleInputChange}
            />
          </Grid>
        </>
      )}

      {type === 2 && (
        <Grid item xs={12} sm={6}>
          <Autocomplete
            id="combo-box-languages"
            value={languages.filter((language: any) => sliderState.languages.includes(language.id))}
            onChange={handleMultiAutoCompleteChange('languages')}
            options={languages}
            multiple
            getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
            renderInput={params => (
              <TextField
                required
                {...params}
                label={t('language')}
                error={errorForm.languages}
                variant="filled"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
          <FormHelperText error={errorForm.languages}>{msgForm.languages}</FormHelperText>
        </Grid>
      )}

      {type === 2 && languages.length > 0 && (
        <Grid item xs={12}>
          {titleLanguages.map((titleLanguage: any, index: number) => (
            <Grid container spacing={2} key={titleLanguage.id}>
              <Grid item xs={4}>
                <TextField
                  label={t('language')}
                  disabled
                  fullWidth
                  margin="normal"
                  value={languages.find((language: any) => language.id === titleLanguage.id).name}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={8}>
                <TextField
                  label={t('title')}
                  fullWidth
                  required
                  margin="normal"
                  value={titleLanguage.title}
                  onChange={handleTitleLanguageChange(index)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  variant="filled"
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  )
}

export default ComplementsInfoForm
